<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
<!--
    --------------------------------------------------------------------------------------------------
    SEE https://community-dc.max.gov/x/qgY0mQ FOR AN OVERVIEW OF HOW ATTACHMENTS HAVE BEEN IMPLEMENTED
    --------------------------------------------------------------------------------------------------
-->
<ng-template #additionalInfoDiv>
    <div style="color:black;font-weight: bold;margin:15px;">Note: Any columns you add here will display to the left of standard Attachment columns (Title, File Name etc.)</div>
</ng-template>

<div *ngIf="IsInDesignMode" class="grid-design-div">
    <div class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}"><mat-label *ngIf="this.ShowLabel">{{this.DisplayName}} <span *ngIf="this.FormField.required" style="color:red">*</span></mat-label></div>
    <app-grid-field-designer [gridFormFieldComponent]="WrappedGridFormFieldComponent">

        <!-- Project attachment-specific content into GridFieldDesigner -->
        <ng-container projectedAdditionalInfo *ngTemplateOutlet="additionalInfoDiv"></ng-container>
    </app-grid-field-designer>
</div>

<div *ngIf="IsInPreviewOrInstanceMode" class="preview-and-instance-modes-div">

    <div class="field-label" *ngIf="this.DisplayName">{{this.DisplayName}}</div>

    <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="openUploadDialog(FormInstanceElement.id)">Upload</button>
    <button mat-stroked-button style="margin:10px;" (click)="toggleShowAll()">{{ToggleShowAllButtonText}}</button>

    <app-grid-field-editor #gridFieldEditor
                           [flavor]="AttachmentsGridFlavor"
                           [formInstance]="FormInstance"
                           [gridFormFieldComponent]="WrappedGridFormFieldComponent"
                           [isFootnotesGrid]="false"
                           (editorGridValidation)="this.handleEditorGridValidation($event)"
                           (conditionalLogicColumnDefsFilter)="this.handleConditionalLogicColumnDefsFilter($event)"
                           (gridEvent)="this.handleGridEvent($event)">
    </app-grid-field-editor>

    <!-- hide the file uploader that's used under the hood -->
    <div style="display: none">
        <app-file-uploader [dataCollectionId]="this.DataCollectionId"
                           [folderId]="this.FolderId"
                           [formInstanceId]="this.FormInstanceId"
                           [formFieldId]="this.FormField.id"
                           [attachmentCount]="this.AttachmentCount"
                           (filesUploaded)="this.handleFilesUploaded($event)">
        </app-file-uploader>
    </div>
</div>
